module.exports = __webpack_public_path__ + "img/maid-cover-1.8eb06270.jpg";